// extracted by mini-css-extract-plugin
export var card = "_iz-5";
export var cardSelected = "_iz-4";
export var image = "_iz-3";
export var modal = "_iz-0";
export var modalContent = "_iz-1";
export var table = "_iz-2";